
export enum BeaconPriorityCd {
	HIGH = 'High',
	LOW = 'Low',
	MEDIUM = 'Medium',
	URGENT = 'Urgent'}

